import script from "./ChapterListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterListModal.vue?vue&type=script&setup=true&lang=js"

import "./ChapterListModal.vue?vue&type=style&index=0&id=2864ca98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2864ca98"]])

export default __exports__